import { useNavigate } from "react-router-dom";

import styles from "./Header.module.scss";

import logo from "../../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useState } from "react";

const Header: React.FC = () => {
  const redirect = useNavigate();
  const path = window.location.pathname;

  const [menu, setMenu] = useState(false);

  return (
    <>
      <div
        className=" d-flex flex-column flex-md-row col-12 mt-4   align-items-md-center justify-content-md-between align-items-start justify-content-start "
        style={{
          backgroundColor: `transparent`,
          zIndex: 2,
          position: "relative",
        }}
      >
        <div
          className={`d-md-flex d-none  flex-row align-items-center justify-content-center col-12 mt-4 ${styles.headerContainer} `}
        >
          <div
            className={`col-2 d-flex flex-row align-items-center justify-content-center  fw-bold cursor-pointer ${
              path.includes("AboutUs") ? "color-white" : "color-greyText"
            }`}
            onClick={() => redirect("/AboutUs")}
          >
            Chi Siamo
          </div>
          <div
            className={`col-2 d-flex flex-row align-items-center justify-content-center  fw-bold cursor-pointer  ${
              path.includes("Pricing") ? "color-white" : "color-greyText"
            }`}
            onClick={() => redirect("/Pricing")}
          >
            Prezzi e Servizi
          </div>
          <div
            className={`col-2 ${styles.logoContainer}`}
            onClick={() => redirect("/")}
          >
            <img src={logo} className={`${styles.logoImg} cursor-pointer`} />
          </div>
          <div
            className={`col-2 d-flex flex-row align-items-center justify-content-center  fw-bold cursor-pointer ${
              path.includes("Products") ? "color-white" : "color-greyText"
            }`}
            onClick={() => redirect("/Products")}
          >
            Prodotti
          </div>
          <div
            className={`col-2 d-flex flex-row align-items-center justify-content-center  fw-bold cursor-pointer ${
              path.includes("Contacts") ? "color-white" : "color-greyText"
            }`}
            onClick={() => redirect("/Contacts")}
          >
            Contatti ed Orari
          </div>
        </div>

        {/* MOBILE */}
        <div
          className={`col-12 flex-row   d-flex d-md-none d-block align-items-center justify-content-start color-white  px-4 `}
          //   style={{ height: "25vh" }}
        >
          <div
            className="d-flex flex-row align-items-center justify-content-center col-1 "
            onClick={() => setMenu(!menu)}
          >
            <FontAwesomeIcon
              icon={faBars as IconProp}
              style={{ fontSize: "2rem" }}
            />
          </div>
          <div
            className={`d-flex flex-row align-items-center  justify-content-center col-10  ${styles.logoContainerSmartphone}`}
            onClick={() => redirect("/")}
          >
            <img src={logo} className={`${styles.logoImgSmartphone} col-12 `} />
          </div>
          <div className="d-flex flex-row align-items-center justify-content-center col-1"></div>
        </div>
      </div>
      {menu && (
        <div
          className={`color-white d-flex flex-column align-items-start justify-content-end col-12 p-5 ${styles.menuSmartphone}`}
        >
          <div
            className="d-flex flex-row light-title-tahoma fw-bold col-12"
            onClick={() => {
              redirect("/AboutUs");
              setMenu(!menu);
            }}
          >
            Chi Siamo
          </div>
          <div
            className="d-flex flex-row light-title-tahoma fw-bold col-12 mt-4"
            onClick={() => {
              redirect("/Pricing");
              setMenu(!menu);
            }}
          >
            Prezzi e Servizi
          </div>
          <div
            className="d-flex flex-row light-title-tahoma fw-bold col-12 mt-4"
            onClick={() => {
              redirect("/Products");
              setMenu(!menu);
            }}
          >
            Prodotti
          </div>
          <div
            className="d-flex flex-row light-title-tahoma fw-bold col-12 mt-4 mb-5"
            onClick={() => {
              redirect("/Contacts");
              setMenu(!menu);
            }}
          >
            Contatti e Orari
          </div>
        </div>
      )}
    </>
  );
};
export default Header;
